import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-life-record-report-order',
  templateUrl: './life-record-report-order.component.html',
  styleUrls: ['./life-record-report-order.component.scss']
})
export class LifeRecordReportOrderComponent implements OnInit {

  requestType : string = "order";
  title : string = "Life Record - صيانات";
  isOrderDone : boolean = true;

  constructor() { }

  ngOnInit() {
  }

}
